module.exports = __webpack_public_path__ + "img/img-science-btn-2.37164e43.png";